import _ from 'lodash';

export const getPackagingUnity = state => state.getIn(['profile', 'packagingUnity']).toJS();
export const getUnitKinds = state => state.getIn(['profile', 'unitKinds']).toJS();
export const getDocTypes = state => state.getIn(['profile', 'typeDocList']).toJS();
export const getTerminals = state => state.getIn(['profile','terminals']).toJS();
export const getVisitIds = state => state.get('visits').keySeq().toJS();
export const getLicensePlates = state => state.get('licensePlates').toJS();
export const getLicensePlate = state => state.get('profile').get('licensePlate');
export const getLocale = state => state.getIn(['profile','locale']);
export const getExecutingTransportCompanies = state => state.getIn(['profile','transCompList']).toJS();
export const getOwnerTransporterId = state => state.getIn(['profile','ownerTransId']);
export const getPrefComp = state => state.getIn(['profile','prefComp']);
export const isAllowed = state => right => _.indexOf(state.getIn(['profile', 'rights']).toJS(), ''+right) !== -1;
export const getUnitStates = state => state.getIn(['profile','unitStates']).toJS();
